export const BOOKING_POLICY = [
  {
    title: "Booking",
    items: [
      "A non-refundable retainer is required to secure your appointment.",
      "Your retainer will be applied toward the total cost of your service.",
    ],
  },
  {
    title: "Cancellation",
    items: [
      "I kindly ask for at least 48 hours' notice if you need to reschedule your appointment.",
      "Cancellations made with less than 48 hours' notice and no-shows will result in the loss of your retainer.",
    ],
  },
  {
    title: "Late Arrivals",
    items: [
      "Please arrive 10 minutes early to allow time to find a parking spot.",
      "If you arrive more than 15 minutes late, your appointment may need to be cancelled, and your retainer will be forfeited.",
    ],
  },
  {
    title: "Before Your Appointment",
    items: [
      "Please arrive 10 minutes early to allow time to find a parking spot. Parking is available at Coles.",
      "As all services are completed with care and time reserved especially for you, refunds are not offered on completed services.",
    ],
  },
  {
    title: "Satisfaction",
    items: [
      "Please let me know if you have any concerns before leaving your appointment. Once you leave the salon, complaints regarding the finished result will not be accepted.",
      "Beauty is an art, and everyone's preferences are different. If you'd like something changed, we can always create a different look at your next appointment.",
    ],
  },
  {
    title: "Health & Safety",
    items: [
      "Please let me know before your appointment if you have any allergies, eye conditions, or medical concerns.",
      "I may refuse a service if it's not safe to proceed.",
    ],
  },
  {
    title: "Privacy & Communication",
    items: [
      "By providing your contact details, you agree that Slavic Lashes & Brows may use your name, phone number and email address to manage your appointment and send booking confirmations, reminders and appointment-related updates.",
      "Your information will be kept secure and will not be sold or used for unrelated purposes.",
    ],
  },
];
